'use client';

import React, {Suspense} from "react";
import ExperienceNavbar from "../../components/ExperienceNavbar";
import ExperienceList from "../../components/ExperienceList";

const Experience = () => {
    return (
        <Suspense fallback={<div>Loading...</div>}>
            <ExperienceNavbar/>
            <ExperienceList/>
        </Suspense>
    );
}

export default Experience;